import { render, staticRenderFns } from "./DataAnggota.vue?vue&type=template&id=3aaa368e&"
import script from "./DataAnggota.vue?vue&type=script&lang=js&"
export * from "./DataAnggota.vue?vue&type=script&lang=js&"
import style0 from "./DataAnggota.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports